export default __webpack_public_path__ + "static/media/placeholder_business01-it-mobile.3b16fb8b.png";